import { render, staticRenderFns } from "./knowledgeList.vue?vue&type=template&id=f1dd527e&scoped=true&"
import script from "./knowledgeList.vue?vue&type=script&lang=js&"
export * from "./knowledgeList.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeList.vue?vue&type=style&index=0&id=f1dd527e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dd527e",
  null
  
)

export default component.exports